import React, { Component } from "react";
import { Table, Button, ButtonGroup, Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { setCustomerName } from "../../reducers/actions";
import { utcToLocal } from "../../utils/dateConvert";

class CustomerTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortString: "name",
      sortDirection: "asc",
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
  }
  componentDidMount() {}
  handleAssetSelection = () => {
    this.props.setCustomerNameAction("abhilash");
  };
  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };

  renderSortHeader = (label, sortKey) => {
    const active = this.state.sortString == sortKey;
    const iconClass = active && this.state.sortDirection == "des"
      ? "fa fa-sort-down"
      : active
        ? "fa fa-sort-up"
        : "fa fa-sort";

    return (
      <button
        className={`customer-sort-button ${active ? "active" : ""}`}
        onClick={() => {
          if (active) {
            this.handleSortDirection();
          } else {
            this.handleSortString(sortKey);
          }
        }}
        type="button"
      >
        {label}
        <i className={iconClass}></i>
      </button>
    );
  };

  render() {
    const { customers } = this.props;
    console.log("customers", customers);
    return (
      <Table className="customer-table" responsive>
        <thead>
          <tr>
            <th>{this.renderSortHeader("Name", "name")}</th>
            <th>Description </th>
            <th>{this.renderSortHeader("Status", "status")}</th>
            <th>{this.renderSortHeader("Created", "created")}</th>
            <th>{this.renderSortHeader("Updated", "updated")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {customers.length === 0 && (
            <tr>
              <td className="customer-empty" colSpan="6">
                No customers match your search.
              </td>
            </tr>
          )}
          {customers.map((customer, index) => {
            return (
              <tr key={customer.id || index}>
                <td><strong>{customer.name}</strong></td>
                <td>{customer.description || "-"}</td>
                <td>
                  <span className={`customer-status customer-status-${(customer.status || "unknown").toLowerCase()}`}>
                    {customer.status || "-"}
                  </span>
                </td>
                <td>{utcToLocal(customer.dbCreated)}</td>
                <td>{utcToLocal(customer.dbUpdated)}</td>
                <td className="customer-actions">
                  <Dropdown as={ButtonGroup}>
                    <Button
                      className="customer-view-button"
                      size="sm"
                      href={`/editCustomer/${customer.id}`}
                    >
                      Edit
                    </Button>

                    <Dropdown.Toggle
                      split
                      className="customer-view-button customer-view-toggle"
                      id="dropdown-split-basic"
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => this.props.onDetail(customer.id)}
                      >
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/groups?customerId=${customer.id}&customerName=${customer.name}`}
                      >
                        Group
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/assets?customerId=${customer.id}&customerName=${customer.name}`}
                        onClick={() => {
                          this.handleAssetSelection();
                        }}
                      >
                        Assets
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/users?customerId=${customer.id}&customerName=${customer.name}`}
                      >
                        Users
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/devices?customerId=${customer.id}&customerName=${customer.name}`}
                      >
                        Devices
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}
const mapStateToProps = (state) => ({
  customerName: state.customerName,
});
const mapDispatchToProps = {
  setCustomerNameAction: setCustomerName,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTable);
